module.exports = __webpack_public_path__ + "static/media/crossfit.85cbedec.svg";